import React from 'react';
import { SectionHeroBoxesProps } from './SectionHeroBoxes.types';
import {
  StyledContainer,
  StyledBoxOne,
  StyledBoxTwo,
  StyledBoxThree
} from './SectionHeroBoxes.styled';

const SectionHeroBoxes: React.FC<SectionHeroBoxesProps> = ({
  boxOne,
  boxTwo,
  boxThree
}) => {
  return (
    <StyledContainer>
      <StyledBoxOne $color={boxOne.textColor} $backgroundColor={boxOne.color}>
        {boxOne.text}
      </StyledBoxOne>
      <StyledBoxTwo $color={boxTwo.textColor} $backgroundColor={boxTwo.color}>
        {boxTwo.text}
      </StyledBoxTwo>
      <StyledBoxThree
        $color={boxThree.textColor}
        $backgroundColor={boxThree.color}
      >
        {boxThree.text}
      </StyledBoxThree>
    </StyledContainer>
  );
};

export default SectionHeroBoxes;
